// import React, { useState } from "react";
// import "./VariationModal.css";

// const VariationModal = ({
//   showModal = false,
//   variations = [],
//   onAdd,
//   onClose,
// }) => {
//   const [selectedVariation, setSelectedVariation] = useState(null);

//   // 🚫 Do not render if modal is closed
//   if (!showModal) return null;

//   return (
//     <div className="variation-modal-overlay" onClick={onClose}>
//       <div
//         className="variation-modal"
//         onClick={(e) => e.stopPropagation()} // prevent close on inner click
//       >
//         {/* Header */}
//         <div className="modal-header border-0">
//           <h5 className="variation-heading">
//             Customise as per your taste
//           </h5>
        
//           <h6 className="variation-heading">
//             Variations :
//           </h6>
//           {/* <button className="btn-close" onClick={onClose} /> */}
//         </div>

//         {/* Body */}
//         <div className="modal-body">
//           {variations.map((item) => (
//             <label
//               key={item.item_variation_id}
//               className={`variation-option ${
//                 selectedVariation === item.item_variation_id ? "active" : ""
//               }`}
//             >
//               <input
//                 type="radio"
//                 name="variation"
//                 checked={selectedVariation === item.item_variation_id}
//                 onChange={() =>
//                   setSelectedVariation(item.item_variation_id)
//                 }
//               />

//               <span className="custom-radio" />

//               <div className="variation-info">
//                 <span className="variation-name">
//                   {item.variation_name}
//                 </span>
//                 <span className="variation-price">
//                  + ₹ {item.variation_price}
//                 </span>
//               </div>
//             </label>
//           ))}
//         </div>

//         {/* Footer */}
//         <div className="modal-footer border-0">
//           <button
//             className="btn btn-outline-secondary cancel-btn"
//             onClick={onClose}
//           >
//             Cancel
//           </button>

//           <button
//             className="btn add-btn"
//             disabled={!selectedVariation}
//             onClick={() => onAdd(selectedVariation)}
//           >
//             Add item to cart
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default VariationModal;






import React, { useEffect, useState } from "react";
import "./VariationModal.css";
import { notifyError } from "../../sharedComponent/notify";

const VariationModal = ({
  showModal,
  item, // full item with variations + addons
  onAdd,
  onClose,
}) => {
  const [currentItem, setCurrentItem] = useState(null);


const [selectedVariationId, setSelectedVariationId] = useState(null);
  /* ---------------- INIT / RESET ---------------- */
  useEffect(() => {
    if (showModal && item) {
      const copy = JSON.parse(JSON.stringify(item));

      // default variation
      if (copy.variations?.length) {
        const active = copy.variations.find(v => v.variation_active === 1);
        copy.variations.forEach(v => (v.selected = false));
        // if (active) active.selected = true;
      }

      // default addons
      copy.addons?.forEach(group => {
        group.addon_items?.forEach(i => {
          if (i.selected === undefined) i.selected = false;
        });
      });

      setCurrentItem(copy);
    } else {
      setCurrentItem(null);
    }
  }, [showModal, item]);

  if (!showModal || !currentItem) return null;

  /* ---------------- HANDLERS ---------------- */

  const selectVariation = (id) => {

   setSelectedVariationId(id);
    setCurrentItem(prev => ({
      ...prev,
      variations: prev.variations.map(v => ({
        ...v,
        selected: v.item_variation_id == id,
      })),
    }));
  };

  const toggleAddon = (groupId, itemId) => {
    setCurrentItem(prev => ({
      ...prev,
      addons: prev.addons.map(group => {
        if (group.addon_group_id !== groupId) return group;

        const selectedCount = group.addon_items.filter(i => i.selected).length;
        const max = Number(group.addon_item_selection_max || 0);
        const min = Number(group.addon_item_selection_min || 0);

        return {
          ...group,
          addon_items: group.addon_items.map(item => {
            if (item.addon_group_item_id !== itemId) return item;

            if (item.addon_group_item_active !== 1 && !item.selected) {
              notifyError("Item not available");
              return item;
            }

            const willSelect = !item.selected;

            if (willSelect && max && selectedCount >= max) {
              notifyError(`Maximum ${max} selections allowed`);
              return item;
            }

            if (!willSelect && selectedCount <= min) {
              notifyError(`Minimum ${min} selection required`);
              return item;
            }

         

            return { ...item, selected: willSelect };
          }),
        };
      }),
    }));
  };

  /* ---------------- PRICE ---------------- */

  const getTotalPrice = () => {
    let total = 0;

    const v = currentItem.variations?.find(v => v.selected);
    if (v) total += Number(v.variation_price || 0);

    currentItem.addons?.forEach(g =>
      g.addon_items.forEach(i => {
        if (i.selected) total += Number(i.addon_group_item_price || 0);
      })
    );

    return total.toFixed(2);
  };

  /* ---------------- ADD ---------------- */

  const handleAdd = () => {


// 🔴 VALIDATE VARIATION SELECTION
if (
  currentItem?.variations?.length > 0 &&
  !currentItem.variations.some(v => v.selected)
) {
  notifyError("please select one variation");
  return;
}


    for (const group of currentItem.addons || []) {
      const selected = group.addon_items.filter(i => i.selected).length;
      const min = Number(group.addon_item_selection_min || 0);
      if (selected < min) {
        notifyError(`Select at least ${min} from ${group.addon_group_name}`);
        return;
      }
    }



    onAdd(currentItem , selectedVariationId);
    onClose();
  };

  /* ---------------- UI ---------------- */

  return (
    <div className="variation-modal-overlay" onClick={onClose}>
      <div className="variation-modal" onClick={e => e.stopPropagation()}>
        <h5 className="variation-heading">Customise as per your taste</h5>

{currentItem.variations?.length > 0 && (
    <h6 className="variation-heading">Variations :</h6>
)}

        

        {/* Variations */}
        <div className="section">
          {currentItem.variations?.map(v =>
            v.variation_active === 1 && (
           
              <label
                key={v.item_variation_id}
                className={`variation-option ${v.selected ? "active" : ""}`}
              
              >
                
           
                <div className="d-flex gap-2 align-items-center">
                <input
                  type="radio"
                  checked={v.selected}
                
                  onChange={() => selectVariation(v.item_variation_id)}
                />
                <span className="custom-radio" />
                <span>{v.variation_name}</span>
                </div>
                <span>+₹{' '}{v.variation_price}</span>
              </label>
            )
          )}
        </div>

        {/* Addons */}
        {currentItem?.addons?.length > 0 && (
            <h6 className="variation-heading">Add Ons :</h6>
        )}
        {currentItem.addons?.map(group => (
          <div className="section" key={group.addon_group_id}>
            <h6 className="addon-title">
              {group.addon_group_name} {' '}
              <small>
                (Min {group.addon_item_selection_min}, Max{" "}
                {group.addon_item_selection_max || "Any"})
              </small>
            </h6>

            {group.addon_items.map(item => (
              <div
                key={item.addon_group_item_id}
                className={`addon-row ${
                  item.selected ? "active" : ""
                } ${item.addon_group_item_active !== 1 ? "disabled" : ""}`}
                onClick={() =>
                  item.addon_group_item_active === 1 &&
                  toggleAddon(group.addon_group_id, item.addon_group_item_id)
                }
              >
            {/* <span className={`checkbox ${item.selected ? "checked" : "checked"}`} /> */}
                <span>{item.addon_group_item_name}</span>
                <span>+₹{' '}{item.addon_group_item_price}</span>
              </div>
            ))}
          </div>
        ))}

        {/* Footer */}
        <div className="modal-footer">
          <div className="price">Price : ₹ {getTotalPrice()}</div>

          <div className="d-flex align-items-center gap-2">
            <button
             className="btn btn-outline-secondary cancel-btn"
             onClick={onClose}
           >
             Cancel
           </button>
          <button className="add-btn" onClick={handleAdd}>
            Add Item to Cart
          </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VariationModal;
